module.exports = __webpack_public_path__ + "images/join-request-created@2x-faf8c768c5975545c41e947b4c2158e9.png";